// A signed-in customer whose email is still the internal @betohalics.app
// placeholder (can't receive mail) must set a real email before using the app.
// While that's true, the forced-email gate owns the screen — other onboarding
// popups (install bonus, what's new) must stay hidden so they can't cover it.
export const needsRealEmail = (user) =>
    !!user &&
    user.role === 'user' &&
    (!user.email || String(user.email).toLowerCase().endsWith('@betohalics.app'));

export default needsRealEmail;
